import { ModuleWithProviders, NgModule } from '@angular/core';



import { LodopService } from './lodop.service';

@NgModule({
  imports: [],
})
export class AdLodopModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AdLodopModule,
      providers: [LodopService],
    };
  }
}
